<ts-page [sidenavConfig]="savedViewsSidebarConfig">
  <app-saved-view-sidebar sidenav [relatedToType]="relatedToTypeCompany"></app-saved-view-sidebar>

  <section main class="main">
    <!-- Header -->
    <ts-page-header>
      <ng-container page-header-title>
        <section class="list__top__title-wrapper">
          <h5 class="list__top__title">{{ savedView()?.name }}</h5>
        </section>
      </ng-container>
      <ng-container page-header-action-buttons>
        <section class="list__bottom__action-buttons">
          @if (
            account?.subdomain !== 'broadway' || (account?.subdomain === 'broadway' && user?.email === 'jw@tbcre.com')
          ) {
            <ts-button
              [appAuthorize]="NewPermission.COMPANIES_SHARING_RECORDS"
              denyAction="disable"
              variant="secondary"
              icon="ts_file-save"
              [matTooltip]="'Export as CSV'"
              (click)="exportCompanies()"
              [loading]="exportingCsv"
            >
              Export
            </ts-button>
          }
          <!--          The old permissions still references Contacts -->
          <ts-button
            [appAuthorize]="newPermissionsEnabled ? NewPermission.COMPANIES_CREATE : Permission.CONTACTS_ADD"
            denyAction="disable"
            variant="primary"
            icon="add"
            [matTooltip]="'Add new company'"
            (click)="openAddCompanyDrawerForm()"
          >
            Add
          </ts-button>
        </section>
      </ng-container>
      <ng-container page-header-action-bar>
        <section class="list__bottom__action-buttons justify-between w-full">
          <div class="flex flex-row items-center gap-2">
            <!-- Search Bar -->
            @if (!nestedFiltersEnabled) {
              <ts-input [formControl]="searchInputControl" type="text" icon="ts_search" placeholder="Search"></ts-input>
            }

            <!-- Column Select Panel Button -->
            <ts-button
              [appAuthorize]="newPermissionsEnabled || Permission.CONTACTS_CONTROL_COLUMNS"
              type="stroked"
              color="accent"
              class="xs:hidden"
              icon="visibility"
              [tsOverlayTriggerFor]="columnsSelectOverlayBox"
              [matTooltip]="'Select columns'"
            >
              Fields
              <ng-container *ngIf="displayColumns.length">
                <ts-badge [value]="displayColumns.length" [type]="'info'"></ts-badge>
              </ng-container>
            </ts-button>

            <!-- Mass Update Menu Button -->
            <ng-container *ngIf="selection.selected.length > 0">
              <ts-button
                type="stroked"
                color="accent"
                [matMenuTriggerFor]="massUpdatePanelMenu"
                [matTooltip]="'Open Mass Update Menu'"
              >
                Update Selected
              </ts-button>

              <!-- Mass Update Menu -->
              <mat-menu #massUpdatePanelMenu="matMenu">
                <button mat-menu-item (click)="openMassAddTagDialog()">
                  <ts-icon icon="label" color="gray"></ts-icon>
                  Update Tags
                </button>
              </mat-menu>
            </ng-container>

            <!-- List Filter Button -->
            <ts-button
              type="stroked"
              color="accent"
              class="xs:hidden"
              icon="ts_filter-list"
              [tsOverlayTriggerFor]="filtersOverlayBox"
              [matTooltip]="'Apply filters'"
            >
              Filter
              <ng-container *ngIf="filterCounter">
                <ts-badge [value]="filterCounter" [type]="'info'"></ts-badge>
              </ng-container>
            </ts-button>

            <!-- Tags Panel Button -->
            <ts-button
              type="stroked"
              color="accent"
              class="xs:hidden"
              icon="ts_tag"
              [tsOverlayTriggerFor]="tagsOverlayBox"
              [matTooltip]="'Filter by tags'"
            >
              Tags
              <ng-container *ngIf="tagsCounter !== 0">
                <ts-badge [value]="tagsCounter" [type]="'info'"></ts-badge>
              </ng-container>
            </ts-button>

            <!-- Undo Nested Field Column Changes Button -->
            @if (nestedFiltersEnabled && !disableUndo()) {
              <ts-button
                appAuthorize="CONTACTS_CONTROL_COLUMNS"
                type="icon"
                color="accent"
                icon="undo"
                class="ml-2 xs:hidden"
                [disabled]="disableUndo()"
                (click)="resetColumns()"
                [matTooltip]="disableUndo() ? 'Default Columns Applied' : 'Reset Columns to Default'"
              ></ts-button>
            }
          </div>

          @if (NewPermission.COMPANIES_PUBLIC_CUSTOM_VIEWS | hasPermission) {
            <ts-menu [items]="viewManagementOptions()" />
          }
        </section>
      </ng-container>
    </ts-page-header>

    <!-- Loading Bar -->
    <ng-container *ngIf="isLoading()">
      <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
    </ng-container>

    <!-- Companies Table -->
    <main class="companies-list" [ngClass]="{ 'search-loading': isLoading() }">
      @if (newTable) {
        <ts-table
          [relatedToRedirectConfig]="relatedToRedirectConfig"
          [columnDefs]="columnDefs"
          [hasActionsColumn]="canCreateEngagement"
          [rowData]="companiesData"
          [data]="routeData"
          [rowSelection]="'multiple'"
          [actions]="tsActions"
          [hasCheckboxColumn]="true"
          [hasOpenDetailsColumn]="true"
          [autoHeight]="false"
          (cellEditingStopped)="onCellEditingStopped($event)"
          (selectionChanged)="onSelectionChanged($event)"
          (onColumnMove)="onColumnMoved($event)"
          (sortChanged)="onSortChanged($event)"
          (openDetails)="goToCompany($event.id)"
        ></ts-table>
      } @else {
        <table
          mat-table
          matSort
          [matSortActive]="sortState?.active"
          [matSortDisableClear]="true"
          [matSortDirection]="sortState?.direction"
          [dataSource]="companiesData"
          [trackBy]="trackByFn"
          cdkDropList
          cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="dropColumns($event)"
          (matSortChange)="sortChanged($event)"
        >
          <!-- Checkbox -->
          <ng-container matColumnDef="checkbox">
            <th mat-header-cell *matHeaderCellDef class="checkbox-header">
              <mat-checkbox
                [color]="'primary'"
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
              ></mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let company" class="checkbox-cell">
              <div class="checkbox-content">
                <mat-checkbox
                  [color]="'primary'"
                  (click)="$event.stopPropagation()"
                  (change)="$event ? toggleCompany(company) : null"
                  [checked]="isCompanySelected(company)"
                ></mat-checkbox>
              </div>
            </td>
          </ng-container>

          <div class="flex flex-col gt-xs:flex-row" [matColumnDef]="column" *ngFor="let column of displayColumns">
            <ng-container *ngIf="lookupField(column) as fieldDef">
              <th
                class="project-table-head bg-cool-gray-50 dark:bg-cool-gray-700 pl-2"
                mat-header-cell
                [mat-sort-header]="fieldDef.meta?.sorting"
                *matHeaderCellDef
                cdkDrag
                cdkDragBoundary=".table-container"
                cdkDragLockAxis="x"
              >
                <div class="drag-handle" cdkDragHandle>
                  <mat-icon [svgIcon]="'drag_indicator'"></mat-icon>
                </div>
                <span class="whitespace-no-wrap"> {{ fieldDef?._parentFieldLabel || '' }} {{ fieldDef?.label }} </span>
              </th>
              <td mat-cell *matCellDef="let company" class="pl-2">
                <ng-container *ngIf="column === 'name'; else editableField">
                  <div class="name-content title-content pl-2">
                    <span class="name">{{ company?.name }}</span>
                  </div>
                </ng-container>
                <ng-template #editableField>
                  <app-editable
                    [fieldDef]="fieldDef"
                    [model]="company"
                    [readonly]="true"
                    [data]="routeData"
                  ></app-editable>
                </ng-template>
              </td>
            </ng-container>
          </div>

          <ng-container matColumnDef="action">
            <th class="project-table-head bg-cool-gray-50 dark:bg-cool-gray-700 pl-2" mat-header-cell *matHeaderCellDef>
              <span class="whitespace-no-wrap"> Actions </span>
            </th>
            <td mat-cell *matCellDef="let company" class="pl-2">
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="addCompanyEngagementModal('Call', company)">Log Call</button>
                <button mat-menu-item (click)="addCompanyEngagementModal('Meeting', company)">Log Meeting</button>
                <button mat-menu-item (click)="addCompanyEngagementModal('Social Media', company)">
                  Log Social Media
                </button>
              </mat-menu>
              <ts-button type="icon" icon="more_horiz" color="accent" [matMenuTriggerFor]="menu"></ts-button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="companiesTableColumns"></tr>
          <tr
            class="company-row"
            data-cy="company-row"
            mat-row
            *matRowDef="let row; columns: companiesTableColumns"
            (click)="goToCompany(row.id)"
          ></tr>
        </table>

        <ng-container *ngIf="(companiesCount$ | async) === 0 && !isLoading()">
          <div class="no-companies">There are no companies!</div>
        </ng-container>
      }
      <!-- Table -->
    </main>

    <!-- Companies Table Footer -->
    <footer class="footer-section flex justify-end items-center" [ngClass]="{ 'search-loading': isLoading() }">
      @if (nestedFiltersEnabled) {
        <ts-paginator
          [totalItems]="(pagination$ | async).filteredCount"
          [pageSize]="(pagination$ | async)?.pageSize"
          [activePage]="(pagination$ | async).currentPage"
          (pageChanged)="onPaginationChange.next($event)"
        ></ts-paginator>
      } @else {
        <ts-paginator
          [totalItems]="pagination.length"
          [pageSize]="pagination.size"
          [activePage]="pagination.page + 1"
          (pageChanged)="onPaginationChange.next($event)"
        ></ts-paginator>
      }
    </footer>
  </section>
</ts-page>
<!-- Column Select Panel -->
<ts-overlay #columnsSelectOverlayBox position="bottom" [transparentBackdrop]="true">
  <div class="companies-field-def-panel">
    <div class="fields-panel-header">
      <div class="new-field">
        <mat-icon [svgIcon]="'search'"></mat-icon>
        <input
          type="text"
          placeholder="Enter field name"
          (input)="filterFields($event)"
          (keydown)="filterFieldsInputKeyDown($event)"
          [maxLength]="50"
          #newTagInput
        />
      </div>
    </div>

    <div class="available-fields">
      <ng-container *ngIf="nestedFiltersEnabled; else noNestedFields">
        <ng-container
          *ngFor="let filteredField of filteredFieldDefs | groupBy: '_parentFieldName' : '_parentFieldLabel'"
        >
          <p *ngIf="filteredField?.groupLabel?.length > 1" class="font-bold text-gray-default p-2">
            {{ filteredField?.groupLabel }}
          </p>
          <ng-container *ngFor="let item of filteredField.items; trackBy: trackByFn">
            <mat-checkbox
              *ngIf="filteredField?.groupLabel?.length > 1 || item?.type !== 'record'"
              [ngClass]="{ 'pl-3': filteredField?.groupLabel?.length > 1 }"
              [disabled]="displayColumns.length < 2 && displayColumns.includes(item?.name)"
              [color]="'primary'"
              [checked]="displayColumns.includes(item?.name)"
              (change)="toggleDisplayColumn(item?.name, $event)"
            >
              {{ item.label }}
            </mat-checkbox>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-template #noNestedFields>
        <mat-checkbox
          *ngFor="let fieldDef of filteredFieldDefs; trackBy: trackByFn"
          [disabled]="displayColumns.length < 2 && displayColumns.includes(fieldDef?.name)"
          [color]="'primary'"
          [checked]="displayColumns.includes(fieldDef?.name)"
          (change)="toggleDisplayColumn(fieldDef?.name, $event)"
        >
          {{ fieldDef.label }}
        </mat-checkbox>
      </ng-template>
    </div>
  </div>
</ts-overlay>

<!-- List Filters Panel -->
<ts-overlay
  #filtersOverlayBox
  position="bottom"
  [transparentBackdrop]="true"
  (closeByBackdropClick)="onCloseByBackdropClick()"
>
  <ts-filter
    size="large"
    [fields]="typeFields | async"
    [filters]="filterValueList | async"
    [lookupContract]="lookupService"
    [hasGroups]="true"
    (addItem)="onAddFilterItem()"
    (filterDefChange)="onFilterDefChanged($event)"
    (filterRemove)="onFilterRemoved($event)"
    (filterClear)="onFilterCleared()"
    (filterApply)="onFilterApplied()"
  ></ts-filter>
</ts-overlay>

<!-- Tags Panel -->
<ts-overlay #tagsOverlayBox position="bottom" [transparentBackdrop]="true">
  <app-tags-panel
    (tagsUpdated)="onTagsUpdated($event)"
    [queryFilters]="queryFilters"
    [relatedToType]="relatedToTypeCompany"
  ></app-tags-panel>
</ts-overlay>
